import { percentageFilter } from '@/utils/filters'

const getters = {
  getRefusalReasonsPrompt(state) {
    if (!state.refusalReasons) return ''

    let prompt = 'Card Motivos de recusa\n'

    prompt += state.refusalReasons
      .map(reason => {
        const percentage = percentageFilter(reason.percentage)
        const newReason = { ...reason, percentage }

        return Object.values(newReason).join(' ')
      })
      .join('\n')

    prompt += '\n\n'

    return prompt
  },

  getConversionReasonsPrompt(state) {
    if (!state.conversionReasons) return ''

    let prompt = 'Card Motivos de conversão\n'

    prompt += state.conversionReasons
      .map(reason => {
        const percentage = percentageFilter(reason.percentage)
        const newReason = { ...reason, percentage }

        return Object.values(newReason).join(' ')
      })
      .join('\n')

    prompt += '\n\n'

    return prompt
  },

  getCsatPrompt(state) {
    if (!state.csat) return ''

    const { answer_rate, score, total_answered } = state.csat

    let prompt = 'Card CSAT'
    prompt += `\nTaxa de resposta: ${percentageFilter(answer_rate || 0)}`
    prompt += `\nNível de satisfação: ${percentageFilter(score || 0)}`
    prompt += `\nQuantidade de resposta: ${percentageFilter(total_answered || 0)}`

    return prompt
  },

  getTopTermsPrompt(state) {
    if (!state.topTerms) return ''

    let prompt = 'Card Termos mais falados\n'

    prompt += state.topTerms
      .map(term => {
        const { word, percentage } = term
        const newTerm = { word, percentage: percentageFilter(percentage) }

        return Object.values(newTerm).join(' ')
      })
      .join('\n')

    prompt += '\n\n'

    return prompt
  },

  getTrendsTermsPrompt(state) {
    if (!state.trendsTerms) return ''

    let prompt = 'Card Tendência de termos do período\n'

    prompt += state.trendsTerms
      .map(term => {
        const { word, percentage } = term
        const newTerm = { word, percentage: percentageFilter(percentage) }

        return Object.values(newTerm).join(' ')
      })
      .join('\n')

    prompt += '\n\n'

    return prompt
  },

  getFeelingsPrompt(state) {
    if (!state.feelings) return ''

    const { negative, positive, neutral } = state.feelings

    let prompt = 'Card Sentimento das conversas'

    prompt += `\nNegativo: ${percentageFilter(negative)}`
    prompt += `\nPositivo: ${percentageFilter(positive)}`
    prompt += `\nNeutro: ${percentageFilter(neutral)}`
    prompt += '\n\n'

    return prompt
  },

  getConversationAveragesPrompt(state) {
    if (!state.conversationAverages) return ''

    let prompt = 'Card Média de conversas\n'

    prompt += state.conversationAverages
      .map(status => {
        const { label, average } = status
        const newAverage = {
          label,
          average: percentageFilter(average)
        }

        return Object.values(newAverage).join(' ')
      })
      .join('\n')

    prompt += '\n\n'

    return prompt
  },

  getAllCardsPrompt(state, getters) {
    let prompt = ''

    prompt += getters.getRefusalReasonsPrompt
    prompt += getters.getConversionReasonsPrompt
    prompt += getters.getCsatPrompt
    prompt += getters.getTopTermsPrompt
    prompt += getters.getTrendsTermsPrompt
    prompt += getters.getFeelingsPrompt
    prompt += getters.getConversationAveragesPrompt

    return prompt
  },

  getSmartSummary(state) {
    return state.smartSummary?.summary.replace(/<br>/g, '\n').replace(/\s+/g, ' ')
  },

  getSmartSummaryId(state) {
    return state.smartSummary?.id_summary
  },

  getSmartSummaryFilter(state) {
    return state.smartSummary?.filter
  },

  isSmartSummaryLiked(state) {
    return state.smartSummary?.is_liked === 1
  },

  isSmartSummaryDisliked(state) {
    return state.smartSummary?.is_liked === -1
  },

  getFilterTags(state) {
    return state.filterTags
  },

  getIsFetchingSmartSummary(state) {
    return state.isFetchingSmartSummary
  }
}

export default getters
